// extracted by mini-css-extract-plugin
export default {"sustainabilityInfoButton":"zpa0U","hideButton":"Tkypl"};